import React from "react";

const SvgScript = ({ color, ...props})=> (
  <svg width="20" viewBox="0 0 20 20" {...props}>
    <path
      d="M16 0H8.01a4 4 0 0 0-4 4v9.99h-3a1 1 0 0 0-1 1v1a4 4 0 0 0 4 4h8a4 4 0 0 0 3.99-4V6h3a1 1 0 0 0 1-1V4a4 4 0 0 0-4-4zm-5.99 17.99h-6a2 2 0 0 1-2-2h7a1 1 0 0 1 1 1v1zm3.99-2a1.991 1.991 0 0 1-1.99 2v-2a2.006 2.006 0 0 0-2-2h-4V4a1.993 1.993 0 0 1 2-2H14v13.99zM16 4V2a2 2 0 0 1 2 2h-2zM8.01 4h4c1.29 0 1 1.26 1 5a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zm5 7.99a1 1 0 0 1-1 1h-4a1 1 0 1 1 0-1.99h4a.994.994 0 0 1 1 .99z"
      fill={color || "currentColor"}
      fillRule="evenodd"
    />
  </svg>
);

export default SvgScript;
